<div data-app-sidebar class="layout__sidebar_mobile"></div>
<ul class="nav__list">
  <li class="nav__item" *ngFor="let item of currentMenu()"><a [routerLink]="item.href" class="nav__link">{{ item.name }}</a></li>
</ul>
